module.exports = __webpack_public_path__ + "img/projectList_bg13.b51c1a5b.png";